import CardCircle1 from '@flow/Device/CardGameDevice/cards/CardCircle1';
import CardCircle2 from '@flow/Device/CardGameDevice/cards/CardCircle2';
import CardCircle3 from '@flow/Device/CardGameDevice/cards/CardCircle3';

import Card1 from '@flow/Device/CardGameDevice/cards/Card1';
import Card2 from '@flow/Device/CardGameDevice/cards/Card2';
import Card3 from '@flow/Device/CardGameDevice/cards/Card3';
import CardGroup1 from '@flow/Device/CardGameDevice/cards/CardGroup1';
import CardGroup2 from '@flow/Device/CardGameDevice/cards/CardGroup2';
import CardGroup3 from '@flow/Device/CardGameDevice/cards/CardGroup3';
import PaxCardGroup1 from '@flow/Device/CardGameDevice/cards/PaxCardGroup1';
import PaxCardGroup2 from '@flow/Device/CardGameDevice/cards/PaxCardGroup2';
import PaxCardGroup3 from '@flow/Device/CardGameDevice/cards/PaxCardGroup3';

const CONSTANTS = {
  BLACK: '#000000',
  ALPHA: 0.3,
  DRAFT_MODE: 1,
  STOPPED_STATUS: 7,
  DATE_FORMAT: 1,
  DEFAULT_DEVICE_ID: 2,
  PAX_DEVICE_IDS: [1, 2, 3, 4, 5, 6],
  USER_NAME_LIMIT: '19',
  CAMPAIGN_NAME_LIMIT: '225',
  TC_DES_LIMIT: '512',
  CAMP_NAME_LIMIT: 47,
  CARD_COLORS: ['#E10B17', '#1D1D1B', '#0069B4'],
  CARD_COLORS_NAME: ['red', 'black', 'blue'],
  CARD_CIRCLE: [CardCircle1, CardCircle2, CardCircle3],
  CARDS: [Card1, Card2, Card3],
  CARDGROUP: [CardGroup1, CardGroup2, CardGroup3],
  PAX_CARDGROUP: [PaxCardGroup1, PaxCardGroup2, PaxCardGroup3],
  WINDOW: typeof window !== 'undefined',
  NOM_GAME_TYPE: 'nom',
  WIN_GAME_TYPE: 'win',
  DC_GAME_TYPE: 'dc',
};

export default CONSTANTS;
